import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";
const TaxrateAdd = (
  state_id,
  zip_code,
  tax_region,
  combined_rate,
  state_rate,
  city_rate,
  special_rate,
  county_rate,
  start_date,
  end_date
) => {
  return axios.post(
    API + "accounting/taxrate-add/",
    {
      state_id,
      zip_code,
      tax_region,
      combined_rate,
      state_rate,
      city_rate,
      special_rate,
      county_rate,
      start_date,
      end_date,
    },
    { headers: authHeader() }
  );
};

const TaxrateEdit = (
  id,
  state_id,
  zip_code,
  tax_region,
  combined_rate,
  state_rate,
  city_rate,
  special_rate,
  county_rate,
  start_date,
  end_date
) => {
  return axios.post(
    API + "accounting/taxrate-edit/" + id + "/",
    {
      state_id,
      zip_code,
      tax_region,
      combined_rate,
      state_rate,
      city_rate,
      special_rate,
      county_rate,
      start_date,
      end_date,
    },
    { headers: authHeader() }
  );
};

const TaxRateGet = (id) => {
  return axios.get(API + "accounting/taxrate-get/" + id + "/", {
    headers: authHeader(),
  });
};

const TaxRateDelete = (id) => {
  return axios.delete(API + "accounting/taxrate-delete/" + id + "/", {
    headers: authHeader(),
  });
};

const TaxRatesService = {
  TaxrateAdd,
  TaxrateEdit,
  TaxRateGet,
  TaxRateDelete,
};
export default TaxRatesService;
